<template>
  <div>
    <div>Wpłaty: {{ payIn | currency }}</div>
    <div>Wydatki: {{ payOut | currency }}</div>
    <div>Oszczędności: {{ savings | currency }}</div>
  </div>
</template>

<script>
export default {
  computed: {
    payIn() {
      return this.$piggyBank.data.sumSalaries(this.$store.getters.salaries);
    },
    payOut() {
      return this.$piggyBank.data.sumExpenses(this.$store.getters.expenses);
    },
    savings() {
      return this.payIn - this.payOut;
    },
  },
};
</script>

<style lang="scss" scoped>
</style>